import React from 'react'
import data from "../../json/Homepage/Templates.json"
import style from "./Template.module.css"
import { Link } from 'react-router-dom'
const Template = () => {
    return (
        <div className='container' >
            <div className={style.templatesContentContainer}>
                <p className={style.templateTitle}>{`{${data.title}}`}</p>
                <h3 className={style.TemplateHeading}>{data.heading}</h3>
                <p className={style.Templatedescription}>{data.description}</p>
                <Link to={"/templates"}>
                    <button className={style.templatebutton}>Explore all template</button>
                </Link>
            </div>
            <div className={style.templateCardsHolder}>
                <Card />
            </div>
        </div>
    )
}

export default Template

export const Card = () => {
    return (
        <>
            {data.templates.map((item, index) => (
                <div className={style.TemplateCardContainer}>
                    <img src={process.env.PUBLIC_URL + item.image} alt="Logo" />
                    <h1 className={style.TemplateCardTitle}>{item.title}</h1>
                    <p>{item.description}</p>
                </div>
            ))}
        </>
    )
}
